"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AccountTable = /** @class */ (function (_super) {
    __extends(AccountTable, _super);
    function AccountTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountTable.prototype.render = function () {
        var headers = this.props.headers;
        return (React.createElement("div", { className: "flex text-navy-dark tracking-normal leading-normal" }, headers.map(function (_a) {
            var title = _a.title, width = _a.width;
            return (React.createElement("div", { key: title, className: "flex flex-col justify-start items-center", style: { width: "" + width } },
                React.createElement("p", { className: "uppercase w-full pb-1-6 font-semibold text-base" }, title)));
        })));
    };
    return AccountTable;
}(React.Component));
exports.AccountTable = AccountTable;
